import { createStore } from "redux";
import reducer from "./reducers";

/* global globalThis */
const store = createStore(reducer, globalThis.__REDUX_DEVTOOLS_EXTENSION__?.());
export default store;

